import React from 'react';
import { NumericFormat } from 'react-number-format';

export function BRLCurrencyFixedFormat(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      decimalScale={2}
      fixedDecimalScale={true}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={'R$ '}
      isNumericString
    />
  );
}